import React from "react";
import {
	List,
	Datagrid,
	TextField,
	ReferenceField,
	EditButton,
	Filter,
	ReferenceInput,
	SelectInput,
	ChipField,
	ReferenceArrayInput,
	SelectArrayInput,
	DateField,
	DateInput,
	TextInput,
	SelectField,
	AutocompleteInput,
	downloadCSV,
	NumberField
} from "react-admin";

import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeRepair } from "../../constant/TypeRepair";
import Actions from "../Actions";
import { HOST } from "../../configs";

const RepairFilter = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<Filter {...props}>
			<SelectInput source="status" choices={typeRepair} />
			<DateInput source="createdAt_lt" label="วันที่แจ้งซ่อมสิ้นสุด" alwaysOn />
			<DateInput source="createdAt_gt" label="วันที่แจ้งซ่อมเริ่มต้น" alwaysOn />
			<TextInput alwaysOn source="ticket_no_contains" />
			<ReferenceInput source="room_inform" reference="room">
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				sort={{ field: 'name', order: 'ASC' }}
				perPage={1000000}
				label="พื้นที่การซ่อม"
				source="type_data"
				reference="repairtypedata"
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				label="การซ่อม"
				source="type"
				reference="repairtype"
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<ReferenceArrayInput
				alwaysOn
				style={{ minWidth: "200px" }}
				source="project"
				reference="project"
				filter={filter}
			>
				<SelectArrayInput optionText="name" />
			</ReferenceArrayInput>
		</Filter>
	);
};


const exporter = (records, fetchRelatedRecords) => {
	records = records.filter((record, index) => index < 6000);
	Promise.all(records.map(async (record) => {
		let newRecord = {};
		let repairStatus = typeRepair.find(x => x.id === record.status).name;
		await fetchRelatedRecords(records, "project", "project").then(res => { newRecord = { ...newRecord, project: res[record.project] ? res[record.project].name : "" }; });
		await fetchRelatedRecords(records, "type_data", "repairtypedata").then(res => { newRecord = { ...newRecord, type_data: res[record.type_data] ? res[record.type_data].name : "" }; });
		await fetchRelatedRecords(records, "type", "repairtype").then(res => { newRecord = { ...newRecord, type: res[record.type] ? res[record.type].name : "" }; });
		await fetchRelatedRecords(records, "user_inform", "user").then(res => { newRecord = { ...newRecord, user_inform: res[record.user_inform] ? res[record.user_inform].email : "" }; });
		await fetchRelatedRecords(records, "room_inform", "room").then(res => { newRecord = { ...newRecord, room_inform: res[record.room_inform] ? res[record.room_inform].name : "" }; });
		const token = localStorage.getItem("token");
		const messages = await fetch(`${HOST}/message?ticket=${record.id}&_limit=1&_sort=createdAt:DESC`, {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`
			},
		});
		const responseJson = await messages.json();
		if (responseJson && responseJson.length > 0 && responseJson[0] && responseJson[0].message)
			newRecord = { ...newRecord, last_message: responseJson[0].message };
		else newRecord = { ...newRecord, last_message: "" };
		return {
			...newRecord,
			ticket_no: record.ticket_no,
			description: record.description,
			status: repairStatus,
			rating: record.rating,
			createdAt: moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss"),
			closed_date: record.closed_date ? moment(record.closed_date).format("YYYY-MM-DD HH:mm:ss") : "",
		};
	})).then(data => {
		const csv = convertToCSV({
			data,
			fields: ["ticket_no", "type", "type_data", "status", "description", "user_inform", "room_inform", "project", "rating", "createdAt", "closed_date", "last_message"] // order fields in the export
		});
		csvDownload(csv, "repair");
	});
};

const csvDownload = (csv, filename) => {
	const fakeLink = document.createElement("a");
	fakeLink.style.display = "none";
	document.body.appendChild(fakeLink);
	const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// Manage IE11+ & Edge
		window.navigator.msSaveOrOpenBlob(blob, `${filename}.csv`);
	} else {
		fakeLink.setAttribute("href", URL.createObjectURL(blob));
		fakeLink.setAttribute("download", `${filename}.csv`);
		fakeLink.click();
	}
};

export const RepairList = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
	return (
		<List
			{...props}
			title="repair.repair"
			bulkActions={false}
			filters={<RepairFilter />}
			actions={<Actions isExport />}
			sort={{ field: "createdAt", order: "DESC" }}
			filterDefaultValues={filter}
			exporter={exporter}
			perPage={50}
		>
			<Datagrid>
				<div />
				<TextField source="ticket_no" />
				<ReferenceField linkType={false} source="room_inform" reference="room">
					<TextField source="name" />
				</ReferenceField>
				{/* <ReferenceField label="Author" source="user_inform" reference="user">
                <TextField source="email" />
            </ReferenceField> */}
				<ReferenceField
					linkType={false}
					source="type_data"
					reference="repairtypedata"
				>
					<TextField source="name" />
				</ReferenceField>
				<ReferenceField linkType={false} source="type" reference="repairtype">
					<TextField source="name" />
				</ReferenceField>
				<SelectField
					source="status"
					optionText={<ChipField source="name" />}
					choices={typeRepair}
				/>
				<SentLine label="" source="isSent" />
				<ReferenceField source="user_inform" reference="user" linkType={false}>
					<TextField source="mobile" />
				</ReferenceField>
				{/* <ReferenceField source="project" reference="project" linkType={false}>
                    <ChipField source="name" />
                </ReferenceField> */}
				<DateField
					source="createdAt"
					locales="th-TH"
					options={{
						day: "numeric",
						month: "short",
						year: "numeric",
						hour: "numeric",
						minute: "numeric"
					}}
				/>
				<DateField
					label="วันปิดงาน"
					source="closed_date"
					locales="th-TH"
					options={{
						day: "numeric",
						month: "short",
						year: "numeric",
						hour: "numeric",
						minute: "numeric"
					}}
				/>
				<NumberField source="rating" />
				<EditButton />
			</Datagrid>
		</List>
	);
};

const SentLine = ({ record = {} }) => record.isSent ? <img style={{ maxWidth: 20, maxHeight: 20 }} src={require("../../statics/images/LINE_APP.png")} /> : null;


// WEBPACK FOOTER //
// ./src/components/repair/RepairList.js